// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".check-mark[data-v-4042dcd6] {\n  color: #7dd012;\n}", ""]);
// Exports
module.exports = exports;
